import { observer } from "mobx-react";
import React, { useRef, useEffect } from "react";
import Sortable from "sortablejs";

interface SortableContainerProps {
  children: React.ReactNode;
  onSortEnd: (sortedKeys: string[]) => void;
  animation?: number;
}

const SortablePlugin: React.FC<SortableContainerProps> = ({
  children,
  onSortEnd,
  animation = 150,
}) => {
  const sortableRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const currentRef = sortableRef.current;

    if (currentRef) {
      const sortable = Sortable.create(currentRef, {
        animation,
        ghostClass: "sortable-ghost",
        onEnd: (evt) => {
          const sortedKeys = Array.from(currentRef.children).map(
            (child) => (child as HTMLElement).dataset.key as string
          );
          onSortEnd(sortedKeys);
        },
      });
      return () => {
        if (currentRef) {
          sortable.destroy();
        }
      };
    }
  }, [children, animation, onSortEnd]);

  return (
    <div ref={sortableRef}>
      {React.Children.map(children, (child, index) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { "data-key": child.key || index } as any)
          : child
      )}
      <style>{`
        .sortable-ghost {
          opacity: 0.5;
          background: #e0e0e0;
        }
      `}</style>
    </div>
  );
};

export default observer(SortablePlugin);
